<template>
  <div>
    <button
      v-if="showLihat"
      v-b-tooltip
      title="Lihat File"
      class="btn btn-primary btn-sm"
      :data-id="'lihat-' + file.id_file_data_permohonan"
      @click="$emit('handleLihat', file)"
    >
      <i class="fa fa-eye mr-2" />Lihat
    </button>
    <button
      v-if="showHapus"
      v-b-tooltip
      title="Hapus File"
      class="btn btn-danger btn-sm btn-hapus-file"
      :data-id="'hapus-' + file.id_file_data_permohonan"
      @click="$emit('handleHapus', file.id_file_data_permohonan)"
    >
      <i class="fa fa-trash" />
    </button>
    <button
      v-if="showUploadUlang"
      v-b-tooltip
      title="Upload Ulang"
      class="btn btn-warning btn-sm"
      :data-id="'upload-ulang-' + file.id_file_data_permohonan"
      @click="$emit('handleUploadUlang', file)"
    >
      <i class="fa fa-redo" />
    </button>
    <button
      v-if="showRiwayatFile"
      title="Lihat Riwayat File"
      v-b-tooltip
      class="btn btn-dark btn-sm"
      :data-id="'riwayat-' + file.id_file_data_permohonan"
      @click="$emit('handleRiwayatFile', file)"
    >
      <i class="fa fa-clock" />
    </button>
    <button
      v-if="showSetValid"
      v-b-tooltip
      title="Set File Valid"
      class="btn btn-success btn-sm btn-valid-file"
      :data-id="'1' + file.id_file_data_permohonan"
      @click="$emit('handleValidasi', [file.id_file_data_permohonan, 1])"
    >
      <i class="fa fa-check" />
    </button>
    <button
      v-if="showSetTidakValid"
      v-b-tooltip
      title="Minta Perbaiki"
      class="btn btn-danger btn-sm btn-valid-file"
      :data-id="'2' + file.id_file_data_permohonan"
      @click="$emit('handleValidasi', [file.id_file_data_permohonan, 2])"
    >
      <i class="fa fa-times" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    role: {
      type: String,
      default: () => null
    },
    operatorPembantu: {
      type: Number,
      default: () => null
    },
    status: {
      type: Number,
      default: () => null
    },
    tahap: {
      type: Number,
      default: () => null
    },
    perluValidDesa: {
      type: Number,
      default: () => null
    },
    perluValidKecamatan: {
      type: Number,
      default: () => null
    },
    perluValidDukcapil: {
      type: Number,
      default: () => null
    },
    file: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      showLihat: true,
      showHapus: false,
      showUploadUlang: false,
      showRiwayatFile: true,
      showSetValid: false,
      showSetTidakValid: false
    }
  },
  mounted () {
    this.getButton()
  },
  methods: {
    getButton () {
      if (this.role === 'Penduduk') {
        if (this.status === 0) {
          this.showHapus = true
          this.showUploadUlang = true
        } else if (this.status >= 1 && !this.file.file) {
          this.showUploadUlang = true
        } else if (this.status === 3) {
          if (this.file.is_valid_desa === 2 || this.file.is_valid_desa === 3) {
            this.showUploadUlang = true
          }
        } else if (this.status === 7) {
          if (this.file.is_valid_kecamatan === 2 || this.file.is_valid_kecamatan === 3) {
            this.showUploadUlang = true
          }
        } else if (this.status === 11) {
          if (this.file.is_valid_dukcapil === 2 || this.file.is_valid_dukcapil === 3) {
            this.showUploadUlang = true
          }
        }
      } else if (this.role === 'Operator Desa' || this.role === 'Kepala Desa') {
        if (this.status < 5 && this.tahap === 6) {
          if (this.file.is_valid_desa !== 1) {
            this.showSetValid = true
          }
          if (this.file.is_valid_desa !== 2) {
            this.showSetTidakValid = true
          }
        }
        if (this.operatorPembantu) {
          if (this.status === 0) {
            this.showHapus = true
            this.showUploadUlang = true
          }
          if (this.status === 3 || this.status === 7 || this.status === 11) {
            if (this.file.is_valid_dukcapil === 2) {
              this.showUploadUlang = true
            }
          }
        }
      } else if (this.role === 'Operator Kecamatan') {
        if (this.status < 9) {
          if (this.file.is_valid_kecamatan !== 1 && this.perluValidKecamatan === 1) {
            this.showSetValid = true
          }
          if (this.file.is_valid_kecamatan !== 2 && this.perluValidKecamatan === 1) {
            this.showSetTidakValid = true
          }
        }
      } else if (this.role === 'Operator Dukcapil' || this.role === 'Operator Dukcapil Kecamatan') {
        if (this.status < 14) {
          if (this.file.is_valid_dukcapil !== 1) {
            this.showSetValid = true
          }
          if (this.file.is_valid_dukcapil != 2) {
            this.showSetTidakValid = true
          }
        }
      }
    }
  }
}
</script>